export default {
  API_PATH: process.env.REACT_APP_API_PATH,
  GRAPHQL_PATH: process.env.REACT_APP_GRAPHQL_PATH,
  GRAPHQL_SUBSCRIPTIONS_PATH: process.env.REACT_APP_GRAPHQL_SUBSCRIPTIONS_PATH,
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID
}



// WEBPACK FOOTER //
// ./src/constants/index.js